module.exports = __webpack_public_path__ + "media/images/logo_levante_branco-9b57b3165d5ee24869348d156e4c31b7.png";